module.exports = __webpack_public_path__ + "img/tai.b61d98d.png";